import G6 from '../core';
import Mousetrap from 'mousetrap';
import {officialPlugin} from '../plugins';
import {initNodeEvent} from './node_event';
import {initEdgeEvent} from './edge_event';
import {behaviorConst, dataConst, edgeStyle, elementNameConst, eventNameConst, nodeStyle} from '../conf';
import {handleBackgroundShapeResize} from '../core/logic/node';
import {handleHeaderButtonClickEvent} from '../core/logic/logic';
import {handleCustomElementResize} from '../../../../static/scripts/util/third_util';
import {getIdStr} from '../data';


/**
 * 拓扑插件-画布舞台事件
 */


/**
 * 拓扑插件-画布舞台-初始化画布舞台事件
 * @param options 配置参数
 * @returns Graph 画布舞台对象
 */
export function initCanvasStage(options) {
  const element = document.getElementById(elementNameConst.defaultContainerName);
  const conf = {
    id: getIdStr(),
    container: elementNameConst.defaultContainerName,
    name: elementNameConst.defaultCanvasName,
    // width: 1920,
    // height: 1080,
    width: element?.offsetWidth || 1920,
    height: element?.offsetHeight || 1080,

    // 超出画布图适应
    // fitView: true,
    // fitCenter: true,
    animate: true,

    // 边或连线始终在中心点
    linkCenter: true,

    // 设置为true，启用 redo & undo 栈功能
    enabledStack: true,

    // 节点和边的层级根据生成的顺序确定
    // groupByTypes: false,

    // 缩放最小/最大比例
    minZoom: dataConst.minZoom,
    maxZoom: dataConst.maxZoom,

    // 画布四周留白
    // fitViewPadding: [20, 20, 20, 20],
    // 节点在默认状态下的样式配置（style）和其他配置
    defaultNode: nodeStyle.defaultStyle,

    // 边在默认状态下的样式配置（style）和其他配置
    defaultEdge: edgeStyle.defaultStyle,

    // 节点不同状态下的样式集合
    nodeStateStyles: nodeStyle.stateStyles,

    // 节点不同状态下的样式集合
    edgeStateStyles: edgeStyle.stateStyles,

    // layout: {
    //   // 布局类型
    //   type: layoutNameConst.grid,
    //   // 防止节点重叠
    //   preventOverlap: true,
    //   linkDistance: 100,
    //   nodeStrength: -30,
    //   edgeStrength: 0.1
    // },
    modes: {
      default: behaviorConst.defaultBehaviorArray,
      joinLine: behaviorConst.joinLineBehaviorArray
    },

    plugins: [officialPlugin.initSnapLine(), officialPlugin.initMenu()]
  };

  if (options) {
    Object.assign(conf, options);
  }

  // 注册
  return new G6.Graph(conf);
}


/**
 * 拓扑插件-画布舞台-初始化画布舞台事件
 * @param that vue实例
 */
export function initCanvasStageEvent(that) {
  const stage = that.getCanvasStage();


  // 处理画布缩放事件
  stage.on(eventNameConst.timingEventName.viewportChange, evt => {
    // 计算背景图片、颜色图形尺寸
    // const scale = 1 - evt.matrix[0];
    // let scaleWidth = stage.getWidth() * scale;
    // scaleWidth = scaleWidth > 0 ? scaleWidth : 0;
    // let scaleHeight = stage.getHeight() * scale;
    // scaleHeight = scaleHeight > 0 ? scaleHeight : 0;
    //
    // const width = scaleWidth + stage.getWidth();
    // const height = scaleHeight + stage.getHeight();
    //
    // const demo = getBgColorShape(that);
    // console.log(demo, '图形', demo?.attr(), demo?.attr().width, demo?.attr().height);
    //
    // console.log(evt.matrix[0], scale, '缩放', evt, stage.getWidth(), stage.getHeight(), '数据', width, height);
    // handleBackgroundShapeResize(that, width, height);
  });


  // 初始化节点相关事件
  initNodeEvent(that);

  // 初始化边相关事件
  initEdgeEvent(that);

}


/**
 * 拓扑插件-画布舞台-初始化画布舞台事件
 * @param that vue实例
 */
export function initCanvasSizeChangeEvent(that) {
  handleCustomElementResize(elementNameConst.defaultContainerName, ele => {
    const stage = that.getCanvasStage();
    stage.changeSize(ele.offsetWidth, ele.offsetHeight);
    
    // 重置背景图片大小
    handleBackgroundShapeResize(that, stage.getWidth(), stage.getHeight());
    stage.emit('custom:canvas:changeSize', stage.getWidth(), stage.getHeight());
  });
}


/**
 * 拓扑插件-画布后台-初始化画布快捷键事件绑定与处理
 */
export function initBindCanvasShortcuts(that) {
  dataConst.shortcuts.forEach(item => {
    Mousetrap.bind(item.key, evt => {
      if (evt.preventDefault) {
        evt.preventDefault();
      } else {
        evt.returnValue = false;
      }

      handleHeaderButtonClickEvent(that, item.eventCode);
      return false;
    });
  });
}


/**
 * 拓扑插件-画布后台-解除快捷键事件绑定
 */
export function unbindCanvasShortcuts() {
  dataConst.shortcuts.forEach(item => {
    Mousetrap.unbind(item.key);
  });
}
